import { FETCH_TEXTURES } from "../actions/types";

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_TEXTURES:
      return action.payload;
    // case FETCH_GYMS_PAGINATION:
    //   return [...state, ...action.payload];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/texturesReducer.js